module.exports = __webpack_public_path__ + "img/159.28d70244.png";